const navBarTranslations = {
  overview: {
    title: "Overview",
    links: {
      home: "Home",
      meals: "Nutrition Program",
      supplements: "Supplements",
      workout: "Workout Program",
      explanation: "Explanation",
    },
  },
  support: {
    title: "Support",
    links: {
      requestSupport: "Request Support",
      bugReport: "Bug & Issues Report",
      inquiries: "Inquiries",
    },
  },
  navBarDocs: {
    description: "Like what you see ? Check us out.",
    actionButton: "View More",
  },
};

export default navBarTranslations;
